<template>
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.375 11.75C9.28328 11.7503 9.19465 11.7169 9.12586 11.6562L6 8.8768L2.87414 11.6562C2.82005 11.7043 2.7532 11.7357 2.68165 11.7467C2.6101 11.7576 2.53692 11.7476 2.47094 11.7179C2.40495 11.6881 2.34898 11.6399 2.30978 11.5791C2.27057 11.5183 2.24981 11.4474 2.25 11.375V2.75C2.25044 2.35231 2.40861 1.97103 2.68982 1.68982C2.97103 1.40861 3.35231 1.25043 3.75 1.25H8.25C8.64769 1.25043 9.02897 1.40861 9.31018 1.68982C9.59139 1.97103 9.74957 2.35231 9.75 2.75V11.375C9.75 11.4745 9.71049 11.5698 9.64017 11.6402C9.56984 11.7105 9.47446 11.75 9.375 11.75Z"
      fill="#7B6CCC"
    />
  </svg>
</template>